import { LicenseStateModel } from '../../models/ecommerce/license.model';

const LICENSE_STATE_LABELS: Record<LicenseStateModel, string> = {
  pending: 'In attivazione',
  active: 'Attivo',
  trial: 'In prova',
  past_due: 'Pagamento in ritardo',
  grace: 'In periodo di tolleranza',
  expired: 'Scaduto',
  suspended: 'Sospeso',
  cancelled: 'Annullato',
};

/**
 * Licenze concluse: non impediscono un nuovo acquisto. Tutte le altre sì,
 * comprese quelle sospese o in attesa, perché un secondo ordine creerebbe una
 * licenza sovrapposta per la stessa applicazione.
 */
const CLOSED_LICENSE_STATES = new Set<LicenseStateModel>(['expired', 'cancelled']);

/** Stato come lo legge il cliente; uno stato nuovo del backend resta leggibile. */
export function licenseStateLabel(state: LicenseStateModel | string): string {
  return LICENSE_STATE_LABELS[state as LicenseStateModel] ?? state;
}

export function isOpenLicenseState(state: LicenseStateModel | string): boolean {
  return !CLOSED_LICENSE_STATES.has(state as LicenseStateModel);
}
